import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import { ITopLevelKeys } from '../entity-data/entity-data.data';
import { EntityDataService } from '../entity-data/entity-data.service';
import { ErrorService } from '../error-reporting/error.service';
import { IResponseInfo } from '../http/http.data';
import { GlobalSearch } from '../search-data/global-search.model';
import { SettingsDataStore } from '../settings-data/settings-data.store';
import { LoggerService } from '../shared/services/logger/logger.service';
import { ItemDataBuilder } from './item-data.builder';
import {
  ITEM_ACCEPT_VERSION,
  ITEM_AUTOCOMPLETE_ACCEPT_VERSION,
  ITEM_SEARCH_ACCEPT_VERSION,
  ItemAutoCompleteTypesEnum,
} from './item-data.data';
import { Item } from './item.model';
import { map } from 'rxjs/operators';

@Injectable()
export class ItemDataService extends EntityDataService {
  protected inputHeaders: any = {
    [ACCEPT_VERSION_HEADER]: ITEM_ACCEPT_VERSION,
  };
  protected searchHeaders: any = {
    [ACCEPT_VERSION_HEADER]: ITEM_SEARCH_ACCEPT_VERSION,
  };

  topLevelKeys: ITopLevelKeys = {
    getKey: 'products',
    postKey: 'created_product',
    putKey: 'updated_product',
    deletedKey: 'deleted_products',
    deleteSingleKey: 'deleted_product',
    getSingleKey: 'product',
    searchResultsKey: 'product_results',
    globalSearchResultsKey: GlobalSearch.KEYS.PRODUCTS,
  };

  constructor(
    authHttpService: AuthHttpService,
    loggerService: LoggerService,
    itemDataBuilder: ItemDataBuilder,
    errorService: ErrorService,
    settingsDataStore: SettingsDataStore
  ) {
    super(
      authHttpService,
      '/products',
      loggerService,
      errorService,
      itemDataBuilder,
      settingsDataStore
    );
  }

  autocompleteBasedOn(
    autocompleteType: ItemAutoCompleteTypesEnum,
    query: string
  ): Observable<List<Item>> {
    return this.authHttpService
      .get(
        `/autocomplete/products/${autocompleteType}`,
        { query },
        { [ACCEPT_VERSION_HEADER]: ITEM_AUTOCOMPLETE_ACCEPT_VERSION }
      )
      .pipe(
        map(
          ({ body, ..._ }: IResponseInfo) =>
            List<string>(body['product_results']).map(
              (value) => this.dataBuilder.buildEntity(value) as Item
            ) as List<Item>
        )
      );
  }
}
